import { defineFcm } from '../shared/factory';

export const FCM_CORGI_USE_ASSETS_DOMAIN_FOR_SCRIPTS = defineFcm('corgi_use_assets_domain_for_scripts')
	.asBoolean()
	.withDefault(false)
	.toConfig();
